import { Component, ElementRef, Inject, OnInit, ViewChild, Input, Output, EventEmitter } from "@angular/core";
import { BaseComponent } from "../../shared/base/base.component";
import { SfAnalyticsService } from '../../services/sf-analytics.service';
import { LossReportService } from "../../services/loss-report.service";
import { RoutingService } from "../../services/routing.service";
import { Router } from "@angular/router";
import { LogService } from "../../services/log.service";
import { MediaUploadService } from "../../services/media-upload.service";



@Component({
  selector: 'olr-damage-photos-add',
  templateUrl: './damage-photos-add.component.html',
  styleUrl: './damage-photos-add.component.css'
})
export class DamagePhotosAddComponent extends BaseComponent implements OnInit{
   public theGrid: string[] = [];

   @Input() photos: { url: string; selected: boolean; name: string;}[] = [];
   @Output() photosAddedEmitter = new EventEmitter<any>();
   uploadFiles: { url: string; selected: boolean; name: string;}[] = [];
   photoPath = 'assets/img/icon-search.svg';
   photoPath2 = 'assets/img/success_32.svg';
   pngHex = '89504e470d0a1a0a';
   jpgHex = 'ffd8ff';
   heicHex1 = '6674797068656963';
   heicHex2 = '667479706d696631';


    typeObj = {
      '89504e470d0a1a0a': 'png',
      'ffd8ff': 'jpg',
      '6674797068656963': 'heic',
      '667479706d696631': 'heic'
    }
   photosAdded = 0;
   photosSelected = 0;
   isSelected = true;
   maxSize = 17;
   mobileDevice = false;
   selectingPhotos = false;
   phoneImageNum = 0;
   allowedTypes=['image/jpeg', 'image/png', 'image/jpg', 'image/heic'];

   @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>; // Reference to the file input element
  constructor(
    @Inject('Window') private window: any,
    public lossReportService: LossReportService,
    public routingService: RoutingService,
    public router: Router,
    private analytics: SfAnalyticsService,
    public logService: LogService,
    private mediaUploadService: MediaUploadService,
    ) {
      super(lossReportService, router, routingService, logService);
     }
ngOnInit(): void {
  this.mobileDevice = this.isMobileDevice();
  const cachedFiles = this.mediaUploadService.getFiles();
  // console.log('cached files', cacehdFiles);
  // console.log(this.photos, cachedFiles, this.uploadFiles)
  if(this.photos.length > 0){

    this.uploadFiles = this.photos;
    this.photosAdded = this.photos.length;
    this.photosSelected = this.photos.length;
  }

  this.theGrid = Array(this.uploadFiles.length) // Initialize the grid with the first image path
  this.analytics.setScreenChannel('filealoss-auto');
  this.analytics.sendData('damage-photos-uploaded');


}

isMobileDevice(): boolean {
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}


convertPhoneName(file: File): File{
  this.phoneImageNum = this.phoneImageNum + 1;
  return new File([file], `phonePhoto-${this.phoneImageNum}`, {
    type: file.type,
    lastModified: file.lastModified
  });
}


onFilesSelected(event: Event) {
  let phoneNameFile: File;
  this.selectingPhotos = true;
  const input = event.target as HTMLInputElement;
  const files = Array.from(input.files|| []);

  const serviceFiles = this.mediaUploadService.getFiles();
  let updatedServiceFiles = [...serviceFiles];
  if (files.length + this.photosAdded <= 15) {
    for(const file of files){
      this.checkFES(file).then((isFEW) => {
        if (isFEW) {
          if(file.name === "image.jpg" && this.isMobileDevice()){
            phoneNameFile = this.convertPhoneName(file);
            const url = URL.createObjectURL(phoneNameFile);
            this.theGrid = Array(this.uploadFiles.length + 1)
            const theFile = { url: url, selected: true, name: phoneNameFile.name };
            this.uploadFiles = [...this.uploadFiles, theFile];
            updatedServiceFiles.push(phoneNameFile);
            this.photosAdded++;
            this.photosSelected++;
            this.isSelected = true;
          } else if (file.name.endsWith('.heic')) {
            const approvedSize = file.size <= this.maxSize*1024*1024 && file.size > 0;
            if(!approvedSize){
              this.window.alert(`File size exceeds limit for : ${file.name}`);

            }
            const isDuplicate =
            this.uploadFiles.some(obj => obj.name === file.name) ||
            serviceFiles.some(cachedFile => cachedFile.name === file.name);
            if (!isDuplicate && approvedSize) {
              this.theGrid = Array(this.uploadFiles.length + 1)
              const theFile = {url: '/assets/img/image_32px.svg', selected: true, name: file.name};
              this.uploadFiles = [...this.uploadFiles, theFile];
              updatedServiceFiles.push(file);
              this.photosAdded++;
              this.photosSelected++;
              this.isSelected = true;
            }
            if (isDuplicate) {
              this.window.alert(`File already exists in the upload list: ${file.name}`);
            }

          } else {
            const allowedType = this.allowedTypes.includes(file.type);
            const approvedSize = file.size <= this.maxSize*1024*1024 && file.size > 0;

            const isDuplicate =
            this.uploadFiles.some(obj => obj.name === file.name) ||
            serviceFiles.some(cachedFile => cachedFile.name === file.name);
            if (isDuplicate) {
              this.window.alert(`File already exists in the upload list: ${file.name}`);
            }
            if(!allowedType){
              this.window.alert(`File type not allowed for : ${file.name}`);

            }
            if(!approvedSize){
              this.window.alert(`File size exceeds limit for : ${file.name}`);

            }
            if(approvedSize && allowedType && !isDuplicate){
              this.theGrid = Array(this.uploadFiles.length + 1)
              const url = URL.createObjectURL(file);
              const theFile = {url: url, selected: true, name: file.name};
              this.uploadFiles = [...this.uploadFiles, theFile];
              updatedServiceFiles.push(file)

              this.photosAdded++;
              this.photosSelected++;
              this.isSelected = true;
            }
          }
        } else {
          this.window.alert(`something went wrong with the image: ${file.name}. Please try a different image.`);
          this.logService.log({id: 'MEDIA_UPLOAD_FILE_SIGNATURE_FAILURE', text: 'The file signature did not match the file extension'} )
        }})
    }
    this.mediaUploadService.setFiles(updatedServiceFiles);

  } else {
    this.window.alert('You can only upload a maximum of 15 photos.');
  }
  this.window['dataLayer'].isfilesSelected =this.mediaUploadService.getFiles().length > 15;
  this.selectingPhotos = false;
}


//take an array or numbers and delete cached files at those indexes
updateCacheRemoval(names: string[]){
  const cachedFiles = this.mediaUploadService.getFiles();
  let updatedCachedFiles : File[] = [];

  cachedFiles.forEach((file, index)=>{

    if(!names.includes(file.name)){
      updatedCachedFiles.push(file);
    }
  })

  this.mediaUploadService.setFiles(updatedCachedFiles);

}

checkFES(file: File): Promise<boolean> {

  return new Promise((resolve, reject)=>{
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onloadend = () => {
      if(reader.result && reader.result instanceof ArrayBuffer){
        const byteArr = new Uint8Array(reader.result.slice(0,12));
        // console.log(`THE BYTE ARRAY : ${byteArr}`)
        const hex = Array.from(byteArr).map(b => b.toString(16).padStart(2, '0')).join('');
        // console.log(`The hex pattern : ${hex}`)
        const isHEIC = (hex.includes(this.heicHex1) || hex.includes(this.heicHex2));
        const isJPG = hex.startsWith(this.jpgHex);
        const isPNG = hex.startsWith(this.pngHex);
        const isExSigMatch = (isHEIC && file.name.endsWith('.heic')) || (isJPG && file.type === 'image/jpg') || (isJPG && file.type === 'image/jpeg') || (isPNG && file.type === 'image/png');
        // console.log(`Saying it is a file extension and signature match would be ${isExSigMatch}`);
        resolve(isExSigMatch);
      }
      reject(false);
    };
  })
}

deletePhoto(){
  let names : string[] = [];

    this.uploadFiles.forEach((file, index)=>{
      if(file.selected){
        names.push(file.name);
        // console.log(this.uploadFiles)
        this.uploadFiles.splice(index, 1);
        // console.log(this.uploadFiles, 'after')
        this.photosSelected--;
        this.deletePhoto();
      }
    })
    this.photosAdded = this.uploadFiles.length;
    if(this.photosAdded == 0){
      // add an emitter here to change photosAdded in the parent component
      this.photosAddedEmitter.emit(this.photosAdded);
      this.isSelected = false;
    }
    this.isSelected = false;
    //update the cache
    this.updateCacheRemoval(names);


}
updateCacheEdit(names: string[]){

  const cachedFiles = this.mediaUploadService.getFiles();
  let updatedCachedFiles : File[] = [];

  cachedFiles.forEach((file)=>{
    if(!names.includes(file.name)){
      updatedCachedFiles.push(file);
    }
  })

  this.mediaUploadService.setFiles(updatedCachedFiles);

}

editPhoto(){
  let names : string[] = [];

    this.uploadFiles.forEach((file, index)=>{
      if(!file.selected){
        names.push(file.name);
        this.uploadFiles.splice(index, 1);
        this.photosSelected--;
        this.editPhoto();

      }
    })
    this.photosAdded = this.uploadFiles.length;
    if(this.photosAdded == 0){
      // add an emitter here to change photosAdded in the parent component
      this.photosAddedEmitter.emit(this.photosAdded);
      this.isSelected = false;
    }
    this.isSelected = false;
    //update the cache
    this.updateCacheRemoval(names);

}

photoSelect(index: number) {
  if (index < 0 || index >= this.uploadFiles.length) {
    return; // Index out of bounds
  }
  let isSelected = this.uploadFiles[index]?.selected;
  if (isSelected) {
    this.photosSelected--;
    if(this.photosSelected === 0){
      this.isSelected = false;
    }
    this.uploadFiles[index].selected = false;
  } else {
    this.photosSelected++;
    if(this.photosSelected > 0){
      this.isSelected = true;
    }
    this.uploadFiles[index].selected = true;
  }

}


answerDamagePhotosQuestion(answer: string): void {
  const step = this.lossReportService.getStepByName('damagePhotos');
  if (step) {
    // Assign the answer to the step's question
    step.question.answers = Array.isArray(answer) ? answer : [answer];
    // Mark the step as completed
    step.completed = true;
    this.editPhoto();
    // Optionally trigger additional logic
    if (step.question.hasDependentQuestions) {
      this.lossReportService.modifyReport();
    } else {
      this.routingService.navigateNext();
    }

  }
}

}
